module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Participating Businesses")]), _vm._v(" "), _c('div', {
    staticClass: "friend-list"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.market.business_markets), function(sellpoint) {
    return _c('div', {
      staticClass: "col-md-6 col-sm-6",
      staticStyle: {
        "min-height": "22em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + sellpoint.business_username
      }
    }, [_c('div', {
      staticClass: "friend-card",
      staticStyle: {
        "min-height": "20em",
        "max-height": "20em",
        "border-bottom-color": "rgb(182, 176, 176)"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "10em",
        "background-size": "contain"
      },
      style: ({
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.38)), url(' + sellpoint.business_banner_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "card-info"
    }, [_c('img', {
      staticClass: "profile-photo-lg",
      attrs: {
        "src": sellpoint.business_brand_image,
        "alt": "user"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "friend-info"
    }, [_c('a', {
      staticClass: "pull-right text-green",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(sellpoint.business_category))]), _vm._v(" "), _c('h5', [_c('a', {
      staticClass: "profile-link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sellpoint.business_tagline))]), _vm._v(" "), _c('a', {
      staticClass: "pull-right",
      staticStyle: {
        "color": "rgb(41, 34, 88)",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + sellpoint.business_username
      }
    }, [_c('i', {
      staticClass: "fa fa-circle"
    }), _vm._v(" visit stall")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 static"
  }, [_c('right-sidebar')], 1)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-2 col-sm-12 col-xs-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('div', {
    staticClass: "wn-loader"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c82643"}!./src/pages/Businesses/template.html
// module id = 234
// module chunks = 0